import Layout from "../Shared/Layout"
import ClientSecuritiesList from "./ClientSecuritiesList";

const Securities = () =>{
    
    return (
        <>
            <Layout>
                <div class="content-body default-height">
                    <div className="container-fluid">
                        <div className="row">
                        <div className="col-xl-12">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="page-titles">
                                            <nav style={{ '--bs-breadcrumb-divider': "'>'" }} aria-label="breadcrumb">
                                                <ol className="breadcrumb">
                                                    <li className="breadcrumb-item text-primary">Titres</li>
                                                </ol>
                                            </nav>
                                            
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                <ClientSecuritiesList/>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Securities; 